import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { ArhamState } from '../mascotTypes';
import { getArhamAsset } from './ArhamAssets';

export interface ArhamCharacterProps {
  state?: ArhamState;
  className?: string;
  alt?: string;
}

export const ArhamCharacter: React.FC<ArhamCharacterProps> = ({
  state = 'idle',
  className = 'w-full h-full object-contain filter drop-shadow-md select-none',
  alt = 'Arham learning mascot',
}) => {
  const asset = getArhamAsset(state as ArhamState);
  console.log("Arham asset:", asset);

  return (
    <div className="relative w-24 h-28 flex items-center justify-center overflow-visible">
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.div
          key={state}
          initial={{ opacity: 0, scale: 0.85, y: 8, rotate: -3 }}
          animate={{ opacity: 1, scale: 1, y: 0, rotate: 0 }}
          exit={{ opacity: 0, scale: 0.85, y: -8, rotate: 3 }}
          transition={{
            type: "spring",
            stiffness: 380,
            damping: 22,
            mass: 0.8
          }}
          className="w-full h-full flex items-center justify-center"
        >
          <img
            src={asset}
            alt={alt}
            className={className}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
